import React from 'react';

const Label = props => <label className='block text-lg font-medium' {...props} />;

export default Label;
